import axios from 'axios';

const api = axios.create({
	baseURL: process.env.REACT_APP_ENVIRONMENT === 'local' ? process.env.REACT_APP_API_GATEWAY : process.env.REACT_APP_API_GATEWAY_SERVER
});

export default api;
